import api from './api'

export const reportService = {
  getSalesReport: (params?: { 
    startDate?: string; 
    endDate?: string; 
    period?: string;
    productId?: string;
    categoryId?: string;
    customerId?: string;
    groupId?: string;
    paymentStatus?: string;
  }) => api.get('/reports/sales', { params }),

  getProfitReport: (params?: { 
    startDate?: string; 
    endDate?: string;
    productId?: string;
    categoryId?: string;
  }) => api.get('/reports/profit', { params }),

  getInventoryReport: (params?: {
    categoryId?: string;
    productId?: string;
    stockStatus?: string;
  }) => api.get('/reports/inventory', { params }),

  getConsignmentReport: (params?: { startDate?: string; endDate?: string }) =>
    api.get('/reports/consignment', { params }),

  getCustomerReport: (params?: {
    groupId?: string;
    customerId?: string;
    startDate?: string;
    endDate?: string;
  }) => api.get('/reports/customers', { params }),

  // Dashboard-style summary endpoints (mapped to dashboard controller)
  getSummary: () =>
    api.get('/dashboard/summary'),

  getSalesTrend: (days: number = 30) =>
    api.get('/dashboard/sales-chart', { params: { days } }),

  getTopProducts: (limit: number = 10) =>
    api.get('/reports/sales', { params: { type: 'top-products', limit } }),

  getTopCustomers: (limit: number = 10) =>
    api.get('/reports/customers', { params: { type: 'top', limit } }),

  // Export reports
  exportSales: (params?: any) =>
    api.get('/reports/sales/export', { params, responseType: 'blob' }),

  exportProfit: (params?: any) =>
    api.get('/reports/profit/export', { params, responseType: 'blob' }),

  getDebtorsReport: (params?: { days?: number }) =>
    api.get('/reports/debtors', { params }),

  getCustomerStatement: (params?: {
    customer_id?: number;
    startDate?: string;
    endDate?: string;
  }) => api.get('/reports/statements', { params }),

  getProductReport: () =>
    api.get('/reports/products'),

  getStockReport: () =>
    api.get('/reports/stock'),

  getReversalReport: (params?: { startDate?: string; endDate?: string }) =>
    api.get('/reports/reversals', { params }),
}
